import { Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import '../../components/subscription-component/style/ManageSubscriptionContainer.scss';
import { getloggedCompanySubscription, getPlanAndFeature } from '../../services/Subscription';
import ComparePlans from './ComparePlans';
import CommonUtil from "../../util/CommonUtils";

const ManageSubscriptionContainer = () => {
  const [monthlyPlanAndFeature, setMonthlyPlanAndFeature] = useState([]);
  const [yearlyPlanAndFeature, setYearlyPlanAndFeature] = useState([]);
  const [subscriptionDetails, setSubscriptionDetails ] = useState({});
  const { navigation } = useOutletContext();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true)
    if(!CommonUtil.isEmpty(subscriptionDetails)){
      getPlanAndFeature()
      .then((res) => {
        if (res.data?.code === "RCI0000" && res.data?.data !== undefined) {
          let monthly = [];
          let yearly = [];
          res.data?.data?.map(pf => {

            // Check if there's a monthly plan and handle it sequence_id
            if (pf["monthly"] !== undefined && pf.monthly.plan.sequence_id >= subscriptionDetails?.plan?.planOrder) {
              // Add monthly plan only if the plan_code is not "0000" or if it matches the subscription plan code
              if (pf.monthly.plan.plan_code !== "0000" || (subscriptionDetails?.plan?.trialPlan && subscriptionDetails?.status == "live")) {
                monthly.push(pf.monthly);
              }
            }
            // Check if there's a yearly plan and add it
            if (pf["yearly"] !== undefined && pf.yearly.plan.sequence_id >= subscriptionDetails?.plan?.planOrder) {
              yearly.push(pf.yearly);
            }
          });

          // Sorting the monthly and yearly plans based on sequence_id
          setMonthlyPlanAndFeature(monthly.sort((o1, o2) => o1.plan.sequence_id - o2.plan.sequence_id));
          setYearlyPlanAndFeature(yearly.sort((o1, o2) => o1.plan.sequence_id - o2.plan.sequence_id));
        }
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("Error fetching subscription: " + error.message);
      });
    }
  }, [subscriptionDetails]);

  useEffect(() => {
    getloggedCompanySubscription().then((res) => {
      if (res.data?.code === "RCI0000") {
        setSubscriptionDetails(res.data?.data);
      }
    });
  }, [])

  return (
    <>
      {!isLoading ? (subscriptionDetails?.plan?.planCode == "0000" ?
        <div className="manage-subscription-container">
          <ComparePlans
            subscriptionDetails={subscriptionDetails}
            isLoading={!isLoading}
            monthlyPlanAndFeature={monthlyPlanAndFeature}
            yearlyPlanAndFeature={yearlyPlanAndFeature}
          />
        </div>
        :
        <div className="manage-subscription-container">

          <div className="manage-subscription-content">
            <ComparePlans
              subscriptionDetails={subscriptionDetails}
              navigation={navigation}
              isLoading={!isLoading}
              monthlyPlanAndFeature={monthlyPlanAndFeature}
              yearlyPlanAndFeature={yearlyPlanAndFeature}
            />
          </div>
        </div>
      )
        : (
          <Box
            sx={{
              display: isLoading ? "flex" : "none",
            }}
          >
            <CircularProgress
              style={{
                top: "50%",
                left: "50%",
                position: "fixed",
                zIndex: 999,
              }}
            />
          </Box>
        )}
    </>
  );
};

export default ManageSubscriptionContainer;
